import { MenuItem, SelectChangeEvent, styled } from "@mui/material";
import { useEffect, useState } from "react";
import colors from "../../theme/themeConstants";
import CustomSelect from "./CustomSelect";

interface IProps {
  onChange: (value: number) => void;
}

const COUNT_YEARS = 100;
const COUNT_MONTHS = 12;
const START_YEAR = new Date().getFullYear();
const START_MONTH = new Date().getMonth();
const START_DAY = new Date().getDate();
const MS_IN_SEC = 1000;

const MONTHS = ((): Array<string> => {
  const items = [];

  for (let i = 0; i < COUNT_MONTHS; i++) {
    items.push(new Date(START_YEAR, i).toLocaleString("default", { month: "long" }));
  }

  return items;
})();

const YEARS = ((): Array<number> => {
  const items = [];

  for (let x = 0; x <= COUNT_YEARS; x++) {
    items.push(START_YEAR - x);
  }

  return items;
})();

const SelectDate = (props: IProps) => {
  const { onChange } = props;

  const [day, setDay] = useState(START_DAY);
  const [month, setMonth] = useState(START_MONTH);
  const [year, setYear] = useState(START_YEAR);

  const calcCountDays = () => {
    return new Date(year, month, 0).getDate();
  };

  const [maxOffsetDays, setMaxOffsetDays] = useState(calcCountDays);

  const calcDays = () => {
    const items = [];
    for (let i = 1; i <= maxOffsetDays; i++) {
      items.push(i);
    }

    return items;
  };

  const [allDays, setAllDays] = useState<number[]>(calcDays);

  const handleDate = (e: SelectChangeEvent) => {
    setDay(Number(e.target.value));
  };

  const handleMonth = (e: SelectChangeEvent) => {
    setMonth(Number(e.target.value));
  };

  const handleYear = (e: SelectChangeEvent) => {
    setYear(Number(e.target.value));
  };

  useEffect(() => {
    setMaxOffsetDays(calcCountDays());
    // eslint-disable-next-line
  }, [month, year])

  useEffect(() => {
    setAllDays(calcDays());
    // eslint-disable-next-line
  }, [maxOffsetDays])

  useEffect(() => {
    const date = Math.round(new Date(year, month, day).getTime() / MS_IN_SEC);
    onChange(date);
    // eslint-disable-next-line
  }, [day, month, year])

  return (
    <Container>
      <CustomSelect
        value={day.toString()}
        onChange={handleDate}
        label="Day"
        border={false}
      >
        {allDays.map(el => (
          <MenuItem value={el.toString()} key={el}>{el}</MenuItem>
        ))}
      </CustomSelect>

      <CustomSelect
        value={month}
        onChange={handleMonth}
        label="Month"
        border={false}
      >
        {MONTHS.map((el, index) => (
          <MenuItem value={index.toString()} key={index}>{ el }</MenuItem>
        ))}
      </CustomSelect>

      <CustomSelect
        value={year}
        onChange={handleYear}
        label="Year"
        border={false}
      >
        {YEARS.map(el => (
          <MenuItem value={el} key={el}>{el}</MenuItem>
        ))}
      </CustomSelect>
    </Container>
  );
};

export default SelectDate;

const Container = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginTop: "2rem",
  "*": {
    fontFamily: "'Poppins', sans-serif!important",
  },
  "& > div": {
    width: "32%"
  },
  "& > div div": {
    width: "100%"
  },
  "& label": {
    color: colors.textDark,
    opacity: 0.5,
    fontSize: "12px"
  }
});
